export const SITE_THIRD_PARTY_SENSORS_CARD_FRENCH_LOCALE = {
  title: "Capteurs tiers installés sur le site",
};
